import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { ConfirmationDialog } from '../../ConfirmationDialog';
import { Button } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { orderLineStatusLookupCodes } from '../../../enums';

const styles = theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  imageContainer: {
    display: 'inherit',
    position: 'relative',
  },

  image: {
    height: 35,
    width: 'auto',
    cursor: 'not-allowed',
  },
  clickableImage: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.3,
    },
  },

  conversionInProgress: {
    filter: 'brightness(0)',
  },

  conversionComplete: {
    //
  },

  conversionCompleteIcon: {
    fill: 'var(--jmi-green)',
    position: 'absolute',
    top: 0,
    right: -8,
    fontSize: 16,
  },
});

const CONVERSION_IMAGES = {
  conversionInProgress: '/assets/images/QVUEV-conversion-in-progress.png',
  conversionComplete: '/assets/images/QVUEV-conversion-complete.png',
  conversionUnavailable: '/assets/images/QVUEV-conversion-unavailable.png',
  conversionAvailable: '/assets/images/bluesky-vue-logo-only.png',
};

const VirtualOrderConversionCellRenderer = withStyles(styles)(props => {
  const { classes, data, onClick } = props;

  const conversionInProgress = data.childOrderCreated && data.childOrderLineStatus !== orderLineStatusLookupCodes['CL-DELIVERED'];
  const conversionComplete = data.childOrderLineStatus == orderLineStatusLookupCodes['CL-DELIVERED'];
  const conversionUnavailable = data.reportCode === 'CQVUEV';
console.log({data});
  const isDisabled = conversionComplete || conversionInProgress || conversionUnavailable;

  const handleClick = evt => {
    evt.stopPropagation();
    evt.preventDefault();
    !!onClick && onClick(props);
  };

  return (
    <div className={classes.container}>
      <div
        //
        className={classes.imageContainer}
        onClick={isDisabled ? undefined : handleClick}
      >
        <img
          className={classnames(classes.image, !isDisabled && classes.clickableImage)}
          src={
            conversionUnavailable 
            ? CONVERSION_IMAGES.conversionUnavailable
              :conversionComplete
              ? CONVERSION_IMAGES.conversionComplete
              : conversionInProgress
              ? CONVERSION_IMAGES.conversionInProgress
              : CONVERSION_IMAGES.conversionAvailable
          }
        />
      </div>
    </div>
  );
});

VirtualOrderConversionCellRenderer.propTypes = {
  classes: PropTypes.object,
  gridData: PropTypes.array,
  onSave: PropTypes.func,
};

export default VirtualOrderConversionCellRenderer;
